<ion-grid>
  <ion-row>
    <ion-col>

      <div style="margin-top: 10px;">
        <ion-button color="primary" id="uzenet">
          <ion-icon slot="start" name="add"></ion-icon>
          Új
        </ion-button>
      </div>
      <ng-container>
        <ngx-datatable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
          [rows]="allomany" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [rowClass]="getRowClass"
          [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column name="Név" prop="name">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Név</b>
              {{ value }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Terminál" prop="brand">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Terminál</b>
              {{ row.brand }} {{row.model}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Műveletek</b>

              <ion-button color="danger" size="small" style="margin-top:0" [id]="'present-alert-'+row.id">
                <ion-icon slot="icon-only" name="trash"></ion-icon>

              </ion-button>
              <ion-alert [trigger]="'present-alert-'+row.id" header="Biztosan törlöd?" [buttons]="alertButtons"
                (didDismiss)="setResult($event,row)"></ion-alert>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>



    </ion-col>
  </ion-row>
</ion-grid>


<ion-modal class="" style="z-index: 1000" #uzenetmodal trigger="uzenet">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button style="background: white; border-radius: 5px" (click)="cancel()" [strong]="true" shape="round"
            color="danger">Mégse</ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button [disabled]="!form.valid" style="background: white; border-radius: 5px" (click)="submit()"
            [strong]="true" shape="round" color="secondary">Mentés</ion-button>
        </ion-buttons>
        <ion-title>Új POS terminál</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="margin: auto;">
      <form [formGroup]="form">
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-select aria-label="POS szolgáltató" interface="popover" placeholder="" label="POS szolgáltató"
                label-placement="stacked" fill="outline" formControlName="brand">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option value="sumup">Sumup</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-select aria-label="POS modell" interface="popover" placeholder="" label="POS modell"
                label-placement="stacked" fill="outline" formControlName="model">
                <ion-icon slot="start" name="cash" aria-hidden="true"></ion-icon>
                <ion-select-option value="solo">Solo</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-input label="API-kulcs" formControlName="token" label-placement="stacked" fill="outline"
                placeholder=""><ion-icon slot="start" name="time" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-input label="Merchant azonosító" formControlName="merchant_id" label-placement="stacked"
                fill="outline" placeholder=""><ion-icon slot="start" name="time"
                  aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-input label="Név" formControlName="name" label-placement="stacked" fill="outline"
                placeholder=""><ion-icon slot="start" name="time" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-input label="Párosító kód" formControlName="pairing_code" label-placement="stacked" fill="outline"
                placeholder=""><ion-icon slot="start" name="time" aria-hidden="true"></ion-icon></ion-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </ion-content>
  </ng-template>
</ion-modal>